<footer :class="$style.footerBar">
  <InventoryHubInfoFooter v-if="isInventoryHub"/>
  <p :class="$style.salesReportFooter" v-if="isSalesReport">{{$t('components.footerbar.sale_report_footer')}}</p>
  <div :class="$style.footerTopDiv">
    <div :class="$style.footerTop">
      <div :class="$style.footerHeading">{{$t('components.footerbar.footer_heading')}}</div>
      <li :class="$style.footerItem">
        <span>{{copyright}}</span>
      </li>
    </div>
    <ul :class="$style.footerList">
      <div :class="$style.footerItemDiv">
        <li :class="$style.footerItem">
          <a
            :id="$vId(this, 'trademarks')"
            :class="$style.footerLink"
            href="http://www.monotype.com/legal/trademarks/"
            target="_blank"
            rel="noopener noreferrer">
            {{$t('components.footerbar.trademarks')}}
          </a>
        </li>
        <li :class="$style.footerItem">
          <a
            :id="$vId(this, 'terms-of-use')"
            :class="$style.footerLink"
            href="http://www.monotype.com/legal/terms-of-use/"
            target="_blank"
            rel="noopener noreferrer">
            {{$t('components.footerbar.terms_of_use')}}
          </a>
        </li>
    
        <li :class="$style.footerItem">
          <a
            :id="$vId(this, 'terms-and-conditions')"
            :class="$style.footerLink"
            href="http://www.monotype.com/legal/terms-and-conditions-of-business/"
            target="_blank"
            rel="noopener noreferrer">
            {{$t('components.footerbar.terms_and_conditions')}}
          </a>
        </li>
    
        <li :class="$style.footerItem">
          <a
            :id="$vId(this, 'privacy')"
            :class="$style.footerLink"
            href="http://www.monotype.com/legal/privacy-policy/"
            target="_blank"
            rel="noopener noreferrer">
            {{$t('components.footerbar.privacy')}}
          </a>
        </li>
    
        <li :class="$style.footerItem">
          <a
            :id="$vId(this, 'licensing')"
            :class="$style.footerLink"
            href="https://www.monotype.com/legal"
            rel="noopener noreferrer"
            target="_blank">
            {{$t('components.footerbar.legal')}}
          </a>
        </li>
      </div>
    </ul>
  </div>
</footer>
